import format from "date-fns/format";

export default {

    computed:{
        profile() {
            return this.$store
              .$db()
              .model("profile")
              .query()
              .first();
          },
        },
        methods:{
          generateID(){
            if(this.profile && this.profile.id){
            let timeDate = format(new Date(), 'yyyy-MM-dd[T]HH:mm:ss')
            let id = this.profile.id + "_" + timeDate
            return id
            }
        }
    }
}